/* ==========================================================================
 * Brand Casa — Custom collection page (PLP) interactivity
 * --------------------------------------------------------------------------
 *   - In-stock toggle
 *   - Shop-by-Size filter (with per-size counts)
 *   - In-collection search (client-side text match)
 *   - Sort (manual/price asc/price desc)
 *   - Read More / Read Less on description
 *   - Card-level colour swatch → image swap
 *   - Card-level size chip highlight when size filter is active
 * ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-bc-coll]');
  if (!root) return;

  // ─── STORY TOGGLE ──────────────────────────────────────────────────────
  var storyToggle = root.querySelector('[data-bc-story-toggle]');
  var storyRest = root.querySelector('[data-bc-story-rest]');
  var storyLabel = root.querySelector('[data-bc-story-toggle-label]');
  if (storyToggle && storyRest) {
    storyToggle.addEventListener('click', function () {
      var open = storyToggle.getAttribute('aria-expanded') === 'true';
      storyToggle.setAttribute('aria-expanded', !open);
      storyRest.hidden = open;
      if (storyLabel) storyLabel.textContent = open ? 'Read More' : 'Read Less';
    });
  }

  // ─── GRID + FILTERING ──────────────────────────────────────────────────
  var grid = root.querySelector('[data-bc-grid]');
  var cards = Array.from(root.querySelectorAll('[data-bc-card]'));
  var empty = root.querySelector('[data-bc-empty]');
  var countEl = root.querySelector('[data-bc-count]');
  var filterResult = root.querySelector('[data-bc-filter-result]');

  var state = {
    query: '',
    size: null,
    inStock: false,
    sort: 'manual'
  };

  function parseSizeAvail(str) {
    // "6:1,8:0,10:1,..." → { "6": true, "8": false, ... }
    var out = {};
    (str || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length === 2) out[bits[0]] = bits[1] === '1';
    });
    return out;
  }

  cards.forEach(function (card) {
    card._meta = {
      title: card.getAttribute('data-title') || '',
      price: parseInt(card.getAttribute('data-price'), 10) || 0,
      sizeAvail: parseSizeAvail(card.getAttribute('data-size-avail')),
      hasStock: card.getAttribute('data-has-stock') === '1'
    };
  });

  function matches(card) {
    var m = card._meta;
    if (state.query && m.title.indexOf(state.query) === -1) return false;
    if (state.inStock && !m.hasStock) return false;
    if (state.size && !m.sizeAvail[state.size]) return false;
    return true;
  }

  function applyFilters() {
    var visible = [];
    cards.forEach(function (card) {
      var show = matches(card);
      card.hidden = !show;
      if (show) visible.push(card);

      // Highlight chip if size filter is active
      if (state.size) {
        var chips = card.querySelectorAll('[data-bc-card-size]');
        chips.forEach(function (chip) {
          chip.classList.toggle('is-filter-match',
            chip.getAttribute('data-bc-card-size') === state.size && !chip.classList.contains('is-unavailable'));
        });
      } else {
        card.querySelectorAll('[data-bc-card-size].is-filter-match').forEach(function (chip) {
          chip.classList.remove('is-filter-match');
        });
      }
    });

    // Sort visible cards
    if (state.sort === 'price-asc') {
      visible.sort(function (a, b) { return a._meta.price - b._meta.price; });
    } else if (state.sort === 'price-desc') {
      visible.sort(function (a, b) { return b._meta.price - a._meta.price; });
    }
    // Re-append in sorted order
    visible.forEach(function (c) { grid.appendChild(c); });

    // Count
    if (countEl) countEl.textContent = visible.length;
    if (empty) empty.hidden = visible.length > 0;

    // Filter result text
    if (filterResult) {
      var bits = [];
      if (state.size) bits.push('UK ' + state.size);
      if (state.inStock) bits.push('In stock only');
      if (bits.length) {
        filterResult.textContent = 'Showing ' + visible.length + ' of ' + cards.length + ' styles · ' + bits.join(' · ');
        filterResult.hidden = false;
      } else {
        filterResult.hidden = true;
      }
    }
  }

  // ─── IN-STOCK TOGGLE ───────────────────────────────────────────────────
  var inStockInput = root.querySelector('[data-bc-instock]');
  if (inStockInput) {
    inStockInput.addEventListener('change', function () {
      state.inStock = inStockInput.checked;
      applyFilters();
    });
  }

  // ─── SIZE FILTER ───────────────────────────────────────────────────────
  var sizeButtons = Array.from(root.querySelectorAll('[data-bc-size]'));
  var sizeClear = root.querySelector('[data-bc-size-clear]');

  // Populate per-size counts
  function refreshSizeCounts() {
    sizeButtons.forEach(function (btn) {
      var uk = btn.getAttribute('data-bc-size');
      var n = 0;
      cards.forEach(function (card) {
        if (card._meta.sizeAvail[uk]) n++;
      });
      var slot = root.querySelector('[data-bc-size-count="' + uk + '"]');
      if (slot) slot.textContent = n ? '(' + n + ')' : '';
    });
  }
  refreshSizeCounts();

  sizeButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var uk = btn.getAttribute('data-bc-size');
      if (state.size === uk) {
        state.size = null;
        sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        if (sizeClear) sizeClear.hidden = true;
      } else {
        state.size = uk;
        sizeButtons.forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
        if (sizeClear) sizeClear.hidden = false;
      }
      applyFilters();
    });
  });
  if (sizeClear) {
    sizeClear.addEventListener('click', function () {
      state.size = null;
      sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
      sizeClear.hidden = true;
      applyFilters();
    });
  }

  // ─── SEARCH ────────────────────────────────────────────────────────────
  var searchInput = root.querySelector('[data-bc-search]');
  var searchDebounce = null;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      searchDebounce = setTimeout(function () {
        state.query = (searchInput.value || '').trim().toLowerCase();
        applyFilters();
      }, 150);
    });
  }

  // ─── SORT ──────────────────────────────────────────────────────────────
  var sortBtn = root.querySelector('[data-bc-sort-btn]');
  var sortMenu = root.querySelector('[data-bc-sort-menu]');
  var sortItems = Array.from(root.querySelectorAll('[data-bc-sort]'));

  if (sortBtn && sortMenu) {
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = sortMenu.getAttribute('data-open') === 'true';
      sortMenu.setAttribute('data-open', !open);
      sortMenu.hidden = open;
      sortBtn.setAttribute('aria-expanded', !open);
    });
    document.addEventListener('click', function () {
      sortMenu.setAttribute('data-open', 'false');
      sortMenu.hidden = true;
      sortBtn.setAttribute('aria-expanded', 'false');
    });
  }
  sortItems.forEach(function (li) {
    li.addEventListener('click', function () {
      state.sort = li.getAttribute('data-bc-sort');
      sortItems.forEach(function (x) { x.setAttribute('aria-selected', x === li); });
      applyFilters();
      if (sortMenu) {
        sortMenu.setAttribute('data-open', 'false');
        sortMenu.hidden = true;
        if (sortBtn) sortBtn.setAttribute('aria-expanded', 'false');
      }
    });
  });
  // Default selected = Featured
  var defaultSort = root.querySelector('[data-bc-sort="manual"]');
  if (defaultSort) defaultSort.setAttribute('aria-selected', 'true');

  // ─── CARD SWATCH → IMAGE SWAP ──────────────────────────────────────────
  root.querySelectorAll('[data-bc-card-swatches]').forEach(function (group) {
    var card = group.closest('[data-bc-card]');
    var modelImg = card && card.querySelector('.bc-coll__card-img--model');
    var productImg = card && card.querySelector('.bc-coll__card-img--product');

    // Update an <img> to a new URL — clear srcset first so the browser
    // doesn't keep serving the original responsive variant from cache.
    function setImgSrc(img, url) {
      if (!img || !url) return;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
    }

    // Apply the active swatch's images to both the default (model) image and
    // the hover (product) image. Each swatch has up to two URLs:
    //   data-swap-img       — the first image for that colour, shown by default
    //   data-swap-img-hover — the second image for that colour, shown on hover
    // If a swatch only has one image for its colour, the hover image falls
    // back to the model image, which keeps the card visually consistent.
    function applySwatch(sw) {
      if (!sw) return;
      var swap = sw.getAttribute('data-swap-img');
      var swapHover = sw.getAttribute('data-swap-img-hover') || swap;
      if (swap) setImgSrc(modelImg, swap);
      if (swapHover) setImgSrc(productImg, swapHover);
    }

    var initialActive = group.querySelector('[data-bc-card-swatch].is-active');
    applySwatch(initialActive);

    group.querySelectorAll('[data-bc-card-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        group.querySelectorAll('[data-bc-card-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
        sw.classList.add('is-active');
        applySwatch(sw);
      });
    });
  });

  // ─── INIT ──────────────────────────────────────────────────────────────
  applyFilters();
})();
